import { RequestValidationError } from './errors.js';
/**
 * Validate a payload with the schema that mirrors the server's own constraints, and
 * return the wire body.
 *
 * The schema does three jobs at once: it rejects what Pydantic would reject, it applies
 * the same defaults the server would apply, and — the reason it matters most — it turns
 * every `Dec` and numeric string into the exact decimal string a `Numeric(20, 4)` column
 * expects. Skipping this and passing a hand-built object is how a JS `number` reaches a
 * quantity field.
 */
export function encodeBody(schema, payload, operationName) {
    const parsed = schema.safeParse(payload);
    if (parsed.success)
        return parsed.data;
    const issues = parsed.error.issues.map((i) => ({
        path: i.path.join('.'),
        message: i.message,
    }));
    throw new RequestValidationError(operationName, issues);
}
//# sourceMappingURL=encode.js.map